import type { ReactNode } from 'react';
import { coloresDesdeHex, TONOS, type Tono } from '../../lib/color';

/**
 * Etiqueta de estado. Dos formas de darle color:
 *   - `tone`: uno de los cuatro semánticos del holding (good / warn / bad /
 *     neutral) o `accent`. Preferido para estados conocidos.
 *   - `color`: hex libre (el de BD). Solo aporta el tono; texto y fondo se
 *     derivan con contraste garantizado (lib/color.ts).
 * `dot` pinta un punto delante, útil en tablas para leer el estado sin color.
 */
export function Badge({
  children,
  color,
  tone,
  dot = false,
  className = '',
  title,
}: {
  children: ReactNode;
  color?: string | null;
  tone?: Tono;
  dot?: boolean;
  className?: string;
  title?: string;
}) {
  const c = tone ? TONOS[tone] : coloresDesdeHex(color);
  return (
    <span
      title={title}
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2 py-0.5 text-xs font-semibold ${className}`}
      style={{ backgroundColor: c.bg, color: c.text, borderColor: c.border }}
    >
      {dot && <span aria-hidden="true" className="h-1.5 w-1.5 shrink-0 rounded-full" style={{ backgroundColor: c.dot }} />}
      {children}
    </span>
  );
}
